import { FIELD, WALL } from './constants';

export function clampPaddleX(x: number, width: number, fieldW = FIELD.w, wall = WALL): number {
  return Math.max(wall, Math.min(fieldW - wall - width, x));
}
